var _page = {
    "handle": "",
    "id": ""
};
var _localData = window.Cookies.get();
var _domain = window.location.origin; 
var _logo = window.localStorage.getItem('_logoUrl'); 
var _storeCode = window.localStorage.getItem('_storeCode'); 
var _headerIcons = window.localStorage.getItem('_headerIcons'); 
var _footerBlock = window.localStorage.getItem('_footerBlock'); 
var _headerBlock = window.localStorage.getItem('_headerBlock');
var _asset_url = "//aracaeventmerch.com/cdn/shop/t/54/assets/REPLACETHIS.css?v=15683"; 
var _headerStyle = window.localStorage.getItem('_headerStyle'); 
var _footerStyle = window.localStorage.getItem('_footerStyle'); 
var isCollectionsPage = (window.location.pathname.indexOf('collections')!= -1)? true:false; 
var isAllCollections = (window.location.pathname.indexOf('collections/all')!= -1)? true:false; 
var _footerStyling = window.localStorage.getItem('_footerStyling'); 

if(isAllCollections) {
  window.location.href = window.location.origin; 
} 

if( (isCollectionsPage && _storeCode != window.location.pathname.split('/').slice(-1)[0].substr(0,3).toUpperCase()) || (window.location.pathname == '/') ) {
//     if(isAllCollections) {
//       if(_storeCode == undefined) {
// 		window.location.href = window.location.origin;
//       } else { 
//       	window.location.replace(window.location.origin + "/collections/"+_storeCode+"-homepage"); 
//       } 
//     } 
  
  	window.localStorage.setItem('_domain', _domain); 
    if(document.getElementsByClassName("header__heading-logo").length > 0) {
        _logo = document.getElementsByClassName("header__heading-logo")[0].getAttribute('srcset'); 
        window.localStorage.setItem('_logoUrl', _logo);
    }
    _headerIcons = [] 
    if(_headerIcons[0] = document.getElementsByClassName("icon icon-account").length > 0){ 
        _headerIcons[0] = document.getElementsByClassName("icon icon-account")[0]; 
    } 
    if(document.getElementsByClassName("icon icon-cart").length > 0) {
        _headerIcons[1] = document.getElementsByClassName("icon icon-cart")[0]; 
    } 
    window.localStorage.setItem('_headerIcons', _headerIcons); 
    _storeCode = window.location.pathname.split('/').slice(-1)[0].substr(0,3).toUpperCase(); 
    window.localStorage.setItem('_storeCode', _storeCode); 
    if(document.getElementsByClassName('shopify-section headerSection').length > 0) { 
        _headerBlock = document.getElementsByClassName('shopify-section headerSection')[0].innerHTML; 
        window.localStorage.setItem('_headerBlock', _headerBlock); 
    } 
    if(document.getElementsByTagName('footer').length > 0) { 
        _footerBlock = document.getElementsByTagName('footer')[0].innerHTML; 
        window.localStorage.setItem('_footerBlock', _footerBlock); 
    }  
    var styling = ''; 
    document.querySelectorAll("style[data-shopify]").forEach(function(i) {
    	if(i.innerHTML.indexOf(':root') != -1){
        	styling += i.innerHTML; 
    	}
    }); 
    window.localStorage.setItem('_footerStyling', styling); 

    if(document.getElementsByClassName("footer_custom_copyright").length > 0) {
        var _customCopyright = document.getElementsByClassName("footer_custom_copyright")[0].innerHTML; 
        window.localStorage.setItem('_customCopyright', _customCopyright);
    }
} 
else {
    if(_logo === undefined) {
        _logo = document.getElementsByClassName("header__heading-logo")[0].getAttribute('srcset'); 
        window.localStorage.setItem('_logoUrl', _logo); 
    } 
    if(_headerIcons === undefined) {
        _headerIcons = [] 
        _headerIcons[0] = document.getElementsByClassName("icon icon-account")[0]; 
        _headerIcons[1] = document.getElementsByClassName("icon icon-cart")[0]; 
        window.localStorage.setItem('_headerIcons', _headerIcons); 
    } 
    if(_storeCode === undefined) {
        _storeCode = document.getElementsByTagName("title")[0].text.trim().split(' ')[0]; 
        window.localStorage.setItem('_storeCode', _storeCode); 
    }
    if(_headerBlock == undefined) {
        _headerBlock = document.getElementsByClassName('shopify-section headerSection')[0].innerHTML; 
        window.localStorage.setItem('_headerBlock', _headerBlock);
    }
    if(_footerBlock == undefined) {
        _footerBlock = document.getElementsByTagName('footer')[0].innerHTML; 
        window.localStorage.setItem('_footerBlock', _footerBlock); 
    } 

    if(_headerStyle == undefined && document.getElementsByClassName('shopify-section headerSection').length > 0) {
        _headerStyle = window.getComputedStyle(document.getElementsByClassName('shopify-section headerSection')[0]); 
        window.localStorage.setItem("_headerStyle", _headerStyle); 
    } 
    if(_footerStyle == undefined && document.getElementsByTagName('footer').length > 0) {
        _footerStyle = window.getComputedStyle(document.getElementsByTagName('footer')[0]); 
        window.localStorage.setItem("_footerStyle", _footerStyle); 
    } 
    if(_footerStyling != undefined) { 
        var styling = document.createElement('style'); 
        styling.innerHTML = _footerStyling; 
        document.getElementsByTagName('body')[0].append(styling); 
    } else {
    	var styling = ''; 
	    document.querySelectorAll("style[data-shopify]").forEach(function(i) {
	        if(i.innerHTML.indexOf(':root') != -1){
        		styling += i.innerHTML; 
    		} 
	    }); 
	    window.localStorage.setItem('_footerStyling', styling); 
    }
} 


if(document.getElementsByTagName('header').length == 0) {
    var _headerContainer = document.createElement('div'); 
     _headerContainer.setAttribute('class', 'shopify-section headerSection'); 
    _headerContainer.innerHTML = window.localStorage.getItem('_headerBlock'); 
     document.getElementsByTagName('main')[0].prepend(_headerContainer); 
     var _stylesheet_url = _asset_url.replace('REPLACETHIS', _storeCode+'-style'); 
     var style_sheet = document.createElement('link'); 
   style_sheet.setAttribute('href', _stylesheet_url); 
   style_sheet.setAttribute('rel', 'stylesheet'); 
   style_sheet.setAttribute('media', 'all'); 
  document.getElementsByTagName('body')[0].append(style_sheet);
  $(".nav-menu").remove()
}

 if(document.getElementsByTagName('footer').length == 0) {
     var _footerBlock = document.createElement('footer'); 
     _footerBlock.innerHTML = window.localStorage.getItem('_footerBlock'); 
     document.getElementsByTagName('main')[0].append(_footerBlock); 
 }

if(window.localStorage.getItem('_customCopyright')) {
    var _customCopyrightContainer = document.getElementsByClassName("footer_custom_copyright")[0];
    _customCopyrightContainer.innerHTML = window.localStorage.getItem('_customCopyright'); 
}

//Array.from(document.getElementsByClassName("link link--text list-menu__item list-menu__item--link")).forEach((i)=>{i.setAttribute('href', i.getAttribute('href')+'?view='+_storeCode)}); 





